/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gp_Subscription_Tab_Tasks_Contactmatrix_Contact_Role1Inputs */

const en_gp_subscription_tab_tasks_contactmatrix_contact_role1 = /** @type {(inputs: Gp_Subscription_Tab_Tasks_Contactmatrix_Contact_Role1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

/**
* | output |
* | --- |
* | "Role" |
*
* @param {Gp_Subscription_Tab_Tasks_Contactmatrix_Contact_Role1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const gp_subscription_tab_tasks_contactmatrix_contact_role1 = /** @type {((inputs?: Gp_Subscription_Tab_Tasks_Contactmatrix_Contact_Role1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gp_Subscription_Tab_Tasks_Contactmatrix_Contact_Role1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_gp_subscription_tab_tasks_contactmatrix_contact_role1(inputs)
});
export { gp_subscription_tab_tasks_contactmatrix_contact_role1 as "gp_subscription_tab_tasks_contactMatrix_contact_role" }